import { Component, getComponentByDomNode } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { Backdrop } from '@swisslife/patterns-base/src/atoms/backdrop/js/backdrop';
import { MoodImage } from '../../mood-image/js/mood-image';
import { MoodImageConversion } from '../../mood-image-conversion/js/mood-image-conversion';

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import eventBus, { SLEvent } from '@swisslife/sl-event-bus/src/sl-event-bus';

enum States {
	Open = 'state-m-quick-links--open',
	Hidden = 'state-m-quick-links--hidden',
}

enum Selectors {
	Toggle = '.js-m-quick-links__toggle',
	List = '.js-m-quick-links__list',
}

export interface IQuickLinksChangeEventItem {
	text: string;
	href: string;
	onClick?: (event: Event) => void;
}

export type IQuickLinksChangeEvent = undefined | null | IQuickLinksChangeEventItem[];

function isGenericMoodImageComponent(componentInstance: any): componentInstance is MoodImage {
	if (!componentInstance) {
		return false;
	}
	return typeof componentInstance.removeWhiteBoxIsHiddenClass === 'function';
}

// The @Component decorator will connect the class with `data-g-name="QuickLinks"` elements.
@Component('QuickLinks')
export class QuickLinks extends GondelJqueryComponent {
	private backdrop: Backdrop;
	private $toggle: JQuery;
	private $template: JQuery;
	private moodImageComponent?: MoodImage | MoodImageConversion;

	public async sync() {
		const eb = await eventBus();
		eb.on(SLEvent.ChangeQuickLinks, this.handleChangeQuickLinks);
	}

	public start() {
		this.backdrop = Backdrop.getComponent();
		this.$toggle = this.$ctx.find(Selectors.Toggle);
		this.$template = this.$ctx.find('.m-link-list__item').eq(0);

		const $moodImage = this.$ctx.closest('.m-mood-image');
		const $moodImageConversion = this.$ctx.closest('.m-mood-image-conversion');

		if ($moodImage.length === 0 && $moodImageConversion.length === 0) {
			// tslint:disable-next-line
			return console.warn(`Use MainNavigation just within a header!`);
		} else {
			if ($moodImage.length) {
				this.moodImageComponent = getComponentByDomNode<MoodImage>($moodImage);
				this.initializeQuickLinks();
			}
			if ($moodImageConversion.length) {
				this.moodImageComponent = getComponentByDomNode<MoodImageConversion>($moodImageConversion);
				this.initializeQuickLinks();
			}
		}
	}

	private createItem = ({ text, href }: IQuickLinksChangeEventItem) => {
		const $elem = this.$template.clone();
		$elem
			.find('.m-link-list__link')
			.attr('href', href)
			.find('.a-link__text')
			.html(text);
		return $elem;
	};

	private handleChangeQuickLinks = (meta: string, items: IQuickLinksChangeEvent) => {
		// this.handelHide();
		this.$ctx.removeClass(States.Hidden);
		this.$ctx.removeClass(States.Open);
		this.$toggle.collapse('hide');
		if (this.moodImageComponent) {
			this.moodImageComponent.removeStateClass('QuickLinksOpen');
		}

		if (isGenericMoodImageComponent(this.moodImageComponent)) {
			this.moodImageComponent.removeWhiteBoxIsHiddenClass();
		}

		if (!Array.isArray(items) || items.length <= 0) {
			this.$ctx.find('.m-link-list--quick').html('');
			this.$ctx.addClass(States.Hidden);
			return;
		}

		const $list = this.$ctx.find('.m-link-list--quick').clone();
		$list.html('');
		items.forEach((item) => this.createItem(item).appendTo($list));
		this.$ctx.find('.m-link-list--quick').replaceWith($list);
		items.forEach((item, index) => {
			if (typeof item.onClick !== 'function') {
				return;
			}
			const $item = this.$ctx
				.find('.m-quick-links__list')
				.find('.m-link-list__item')
				.eq(index)
				.find('.m-link-list__link');
			if (!$item || $item.length <= 0) {
				return;
			}
			$item.on('click', (event: Event) => {
				if (this.moodImageComponent) {
					this.moodImageComponent.removeStateClass('QuickLinksOpen');
				}
				this.$toggle.collapse('hide');
				if (typeof item.onClick !== 'function') {
					return;
				}
				item.onClick(event);
			});
		});
		this.$ctx.removeClass(States.Hidden);
	};

	private initializeQuickLinks() {
		this.$toggle.on('show.bs.collapse', this.handelShow);
		this.$toggle.on('shown.bs.collapse', this.handelShown);
		this.$toggle.on('hide.bs.collapse', this.handelHide);
		this.$toggle.on('hidden.bs.collapse', this.handelHidden);
	}

	private handelShow = () => {
		if (!this.moodImageComponent) {
			return;
		}
		this.moodImageComponent.toggleStateClass('QuickLinksOpen', true);
		this.backdrop.show({
			component: 'QuickLinks',
			modifiers: [],
			onInteraction: (ev: string) => {
				// onInteractionHook hides the quicklinks on backdrop click
				if (ev === 'click') {
					this.$toggle.collapse('hide');
				}
			},
		});
	};
	private handelShown = () => {
		if (!this.moodImageComponent) {
			return;
		}
		this.$ctx.addClass(States.Open);
	};
	private handelHide = () => {
		if (!this.moodImageComponent) {
			return;
		}
		this.backdrop.hide();
	};
	private handelHidden = () => {
		if (!this.moodImageComponent) {
			return;
		}
		this.$ctx.removeClass(States.Open);
		this.moodImageComponent.removeStateClass('QuickLinksOpen');
	};
}
